import "./SidebarLayout.css";

/** Footer icon rows: full-width + label when expanded; narrow hit target when collapsed (label clipped). */
export function sidebarFooterTargetClass(navExpanded: boolean): string {
  return navExpanded
    ? "sidebar-footer-target sidebar-footer-target--expanded"
    : "sidebar-footer-target sidebar-footer-target--collapsed";
}

export function sidebarFooterLabelClass(navExpanded: boolean): string {
  return navExpanded
    ? "sidebar-footer-label sidebar-footer-label--expanded"
    : "sidebar-footer-label sidebar-footer-label--collapsed";
}

/** Main nav link labels (Ideas, etc.) fade when rail collapsed */
export function sidebarNavLinkLabelClass(navExpandedChrome: boolean): string {
  return navExpandedChrome
    ? "sidebar-nav-link-label sidebar-nav-link-label--visible"
    : "sidebar-nav-link-label sidebar-nav-link-label--hidden";
}

/** “Add New Idea” label */
export function sidebarNavAddTextClass(navExpandedChrome: boolean): string {
  return navExpandedChrome
    ? "sidebar-nav-add-text sidebar-nav-add-text--visible"
    : "sidebar-nav-add-text sidebar-nav-add-text--hidden";
}
